import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';

import { PublicFooter } from '../components/public/PublicFooter';
import { PublicHeader } from '../components/public/PublicHeader';

export function PublicLayout() {
  const location = useLocation();
  const isRegistrationRoute = location.pathname === '/register';

  return (
    <div className={`site-root min-h-screen bg-white text-slate-900 ${isRegistrationRoute ? 'registration-layout' : ''}`}>
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <PublicHeader />
      <div id="main-content"><Outlet /></div>
      {!isRegistrationRoute && <PublicFooter />}
      <ScrollRestoration />
    </div>
  );
}
